var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-404"},[_c('Subheader'),_c('h3',{staticClass:"error"},[_vm._v("PAGE NOT FOUND")]),_c('p',{staticClass:"link"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("\n      Return Home\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }